$(document).ready(function(){

	// -- Hamburger --
	$('.btn--menu').on('click', function(){
		$('.header__menus fadeIn').removeClass('onscreen');
		$('body').toggleClass('menus--open');
		$(this).toggleClass('active');
		if ($('body').hasClass('menus--open')) {
			$('.header__menus fadeIn').addClass('onscreen');
			$('.header a').attr('tabindex', '0');
			$('.header__mainMenu > nav > ul > li:nth-child(1) > div > a').focus();
		} else {
			$('.header__menus fadeIn').removeClass('onscreen');
			$('.header__mainMenu a, .header__subMenu a').attr('tabindex', '-1');
		}
	});

	$(window).on('load ready resize orientationchange', function(){
	  if ($(window).width() < 768) {
			$('.btn--socialMenu').on('click', function(){
				if ($('.header__socialMedias').hasClass('active')) {
					$('.header__socialMedias').removeClass('active');
					$('.btn--socialMenu').parent().prevAll().fadeIn('400');
				} else {
					$(this).parent().prevAll().fadeOut('400', function(){
						$('.header__socialMedias').addClass('active');
					});
				}
			});
	  } else {
			$('.header__socialMedias').removeClass('active');
			$('.btn--socialMenu').parent().prevAll().fadeIn('400');
	  }
	});

	$('[aria-expanded]').on('click', function(){
		$(this).attr('aria-expanded', function(index, attr){
	    return attr == 'true' ? 'false' : 'true';
		});
	});

});